import {
	Component,
	EventEmitter,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import { EChartsOption } from 'echarts';
import { Subscription } from 'rxjs';
import {
	CampaignPerformanceChartConfig,
	ConversationInsightsChartConfig,
	PlatformOptionConst,
	WidgetLiveCampaignConst,
} from '../../../core/const';
import { PastTimeEnum } from '../../../core/enums';
import { MainArea } from '../../../core/enums/main-area.enum';
import { Parameter } from '../../../core/models/util/api-adapter-service-models';
import { AppResponse } from '../../../core/models/util/api-dto/response-models/app-response';
import { AppResponseAdl } from '../../../core/models/util/api-dto/response-models/app-response-adl';
import { ApiAdapterServiceService } from '../../../core/services';
import { CampaignCountFinalResponseDtoExternal } from '../../models/campaign-count-final-response-dto.model';
import { ConversationChartResponseDto } from '../campaign-index/models/conversation-chart-response-dto.model';
import { PerformanceChartResponseDto } from '../campaign-index/models/performance-chart-response-dto.model';

@Component({
	selector: 'lib-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
	public currentViews = MainArea;
	public pastTime = PastTimeEnum;

	public channelOption: any[] = PlatformOptionConst;
	public performanceCategories: string[] = [];
	public totalCmpn: number[] = [];
	public deliveryRt: number[] = [];
	public costDesc: number[] = [];
	public convsData: any[][] = [];

	public widgetLiveCampaign = WidgetLiveCampaignConst;
	public conversationChartData: EChartsOption;
	public performanceChartData: EChartsOption;
	public selectedPlatform: any = '';
	public filterEvent: any = 'currentWeek';

	private subscribers: Subscription[] = [];

	@Output() currentView = new EventEmitter<MainArea>();

	constructor(private apiAdapterService: ApiAdapterServiceService) {}

	ngOnInit(): void {}

	public changeCurrentView(area: MainArea) {
		this.currentView.emit(area);
	}

	public filterChart(event: string) {
		if (!this.selectedPlatform) {
			return;
		}

		const timeUnit =
			event == PastTimeEnum.Today
				? 'daily'
				: event == PastTimeEnum.CurrentWeek
				? 'weekly'
				: event == PastTimeEnum.CurrentMonth
				? 'monthly'
				: '';

		/* const parameterList: Array<Parameter> = [
			{
				name: 'timeUnit',
				value: timeUnit,
				in: 'query',
				type: 'String',
			},
			{
				name: 'clientId',
				value: localStorage.getItem('telin.clientId'),
				in: 'query',
				type: 'String',
			},
			{
				name: 'platform',
				value: this.selectedPlatform,
				in: 'query',
				type: 'String',
			},
		]; */

		const subs = this.apiAdapterService
			.executeApiRequest([], '/campaign/count', 'GET')
			.subscribe(
				(res: AppResponse<CampaignCountFinalResponseDtoExternal>) => {
					const date =
						(res?.data?.totalCampaignPercent ?? 0) +
						'% Since ' +
						this.getStatictsWidgetString(event);

					this.widgetLiveCampaign[0].arrow =
						res?.data?.totalCampaignPercent > 0
							? '../../../../assets/svg/icon-up-arrow.svg'
							: '../../../../assets/svg/icon-down-arrow.svg';
					this.widgetLiveCampaign[0].value =
						res?.data?.totalCampaign ?? 0;
					this.widgetLiveCampaign[0].date = date;
					this.widgetLiveCampaign[0].dateclass =
						res?.data?.totalCampaignPercent > 0
							? 'greenpercent'
							: 'redpercent';

					this.widgetLiveCampaign[1].arrow =
						res?.data?.totalCampaignPercent > 0
							? '../../../../assets/svg/icon-up-arrow.svg'
							: '../../../../assets/svg/icon-down-arrow.svg';
					this.widgetLiveCampaign[1].value =
						res?.data?.totalLive ?? 0;
					this.widgetLiveCampaign[1].date = date;
					this.widgetLiveCampaign[1].dateclass =
						res?.data?.totalCampaignPercent > 0
							? 'greenpercent'
							: 'redpercent';

					this.widgetLiveCampaign[2].arrow =
						res?.data?.totalCampaignPercent > 0
							? '../../../../assets/svg/icon-up-arrow.svg'
							: '../../../../assets/svg/icon-down-arrow.svg';
					this.widgetLiveCampaign[2].value =
						res?.data?.totalPending ?? 0;
					this.widgetLiveCampaign[2].date = date;
					this.widgetLiveCampaign[2].dateclass =
						res?.data?.totalCampaignPercent > 0
							? 'greenpercent'
							: 'redpercent';
				}
			);

		this.subscribers.push(subs);

		this.getPerformanceDetails(timeUnit);
		this.getConversationDetails(timeUnit);
	}

	private getPerformanceDetails(timeUnit: string) {
		if (!this.selectedPlatform) {
			return;
		}

		this.setPerformanceChartData();

		const parameterList: Array<Parameter> = [
			{
				name: 'timeUnit',
				value: timeUnit,
				in: 'query',
				type: 'String',
			},
			{
				name: 'clientId',
				value: localStorage.getItem('telin.clientId'),
				in: 'query',
				type: 'String',
			},
			{
				name: 'platform',
				value:
					this.selectedPlatform === 'WHATSAPP'
						? 'WA'
						: this.selectedPlatform,
				in: 'query',
				type: 'String',
			},
		];

		const subs = this.apiAdapterService
			.executeApiRequest(
				parameterList,
				'/report/campaign/performance',
				'GET'
			)
			.subscribe((res: AppResponseAdl<PerformanceChartResponseDto>) => {
				this.performanceCategories = [];
				this.totalCmpn = [];
				this.deliveryRt = [];
				this.costDesc = [];

				if (res?.data && Object.entries(res.data).length !== 0) {
					for (let item of res.data.categories) {
						this.performanceCategories.push(item);
					}
					for (let series of res.data.series) {
						if (series.name === 'Total Campaign') {
							this.totalCmpn = series.data?.map(value => value);
						} else if (series.name === 'Delivery Rate') {
							this.deliveryRt = series.data?.map(value => value);
						} else if (series.name === 'Cost Distribution') {
							this.costDesc = series.data?.map(value => value);
						}
					}

					this.setPerformanceChartData();
				}
			});

		this.subscribers.push(subs);
	}

	private setPerformanceChartData() {
		this.performanceChartData = ConversationInsightsChartConfig;
		this.performanceChartData.xAxis.data = this.performanceCategories;
		this.performanceChartData.series[0].data = this.deliveryRt;
		this.performanceChartData.series[1].data = this.totalCmpn;
		this.performanceChartData.series[2].data = this.costDesc;
	}

	private getConversationDetails(timeUnit: string) {
		if (!this.selectedPlatform) {
			return;
		}

		this.setConversationChartData();

		const parameterList: Array<Parameter> = [
			{
				name: 'timeUnit',
				value: timeUnit,
				in: 'query',
				type: 'String',
			},
			{
				name: 'clientId',
				value: localStorage.getItem('telin.clientId'),
				in: 'query',
				type: 'String',
			},
			{
				name: 'platform',
				value:
					this.selectedPlatform === 'WHATSAPP'
						? 'WA'
						: this.selectedPlatform,
				in: 'query',
				type: 'String',
			},
		];

		const subs = this.apiAdapterService
			.executeApiRequest(
				parameterList,
				'/report/campaign/conversation',
				'GET'
			)
			.subscribe((res: AppResponseAdl<ConversationChartResponseDto>) => {
				this.convsData = [];

				if (res?.data) {
					for (let i = 0; i < res.data.categories?.length; i++) {
						this.convsData[i] = new Array();
						this.convsData[i].push(res.data.categories[i]);

						for (let j = 1; j <= res.data.series?.length; j++) {
							this.convsData[i].push(
								res.data.series[j - 1].data[i]
							);
						}
					}

					this.setConversationChartData();
				}
			});

		this.subscribers.push(subs);
	}

	private setConversationChartData() {
		this.conversationChartData = CampaignPerformanceChartConfig;
		this.convsData.forEach(data => {
			if (data) {
				this.conversationChartData.dataset.source.push(data);
			}
		});
	}

	private getStatictsWidgetString(event: string): string {
		return event == PastTimeEnum.Today
			? PastTimeEnum.Yesterday
			: event == PastTimeEnum.CurrentWeek
			? PastTimeEnum.LastWeek
			: event == PastTimeEnum.CurrentMonth
			? PastTimeEnum.LastMonth
			: '';
	}

	ngOnDestroy(): void {
		this.subscribers.forEach(each => each.unsubscribe());
	}
}
